import { render, staticRenderFns } from "./place.vue?vue&type=template&id=6a23ffbc"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"
import style0 from "./place.vue?vue&type=style&index=0&id=6a23ffbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports